import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

function Tooltip({ text, children, position = 'top' }) {
  const [isVisible, setIsVisible] = useState(false);

  const getPositionStyles = () => {
    switch (position) {
      case 'bottom':
        return { top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '8px' };
      case 'left':
        return { right: '100%', top: '50%', transform: 'translateY(-50%)', marginRight: '8px' };
      case 'right':
        return { left: '100%', top: '50%', transform: 'translateY(-50%)', marginLeft: '8px' };
      case 'top':
      default:
        return { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '8px' };
    }
  };

  const getArrowStyles = () => {
    switch (position) {
      case 'bottom':
        return { top: '-6px', left: '50%', transform: 'translateX(-50%)', borderBottomColor: '#333' };
      case 'left':
        return { right: '-6px', top: '50%', transform: 'translateY(-50%)', borderLeftColor: '#333' };
      case 'right':
        return { left: '-6px', top: '50%', transform: 'translateY(-50%)', borderRightColor: '#333' };
      case 'top':
      default:
        return { bottom: '-6px', left: '50%', transform: 'translateX(-50%)', borderTopColor: '#333' };
    }
  };

  return (
    <span 
      className="tooltip-wrapper"
      style={{ 
        position: 'relative', 
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'help'
      }}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <span
          className="tooltip-content"
          style={{
            position: 'absolute',
            backgroundColor: '#333',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '6px',
            fontSize: '0.85rem',
            whiteSpace: 'nowrap',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            ...getPositionStyles()
          }}
        >
          {text}
          <span
            className="tooltip-arrow"
            style={{
              position: 'absolute',
              width: 0,
              height: 0,
              border: '6px solid transparent',
              ...getArrowStyles()
            }}
          />
        </span>
      )}
    </span>
  );
}

// Composant LabelWithTooltip pour les formulaires
export function LabelWithTooltip({ label, tooltip, htmlFor }) {
  return (
    <label htmlFor={htmlFor} style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '6px',
      cursor: 'pointer'
    }}>
      {label}
      <Tooltip text={tooltip}>
        <HelpCircle size={14} color="#3a86ff" />
      </Tooltip>
    </label>
  );
}

export default Tooltip;
